// src/pages/WixBridge.jsx
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import instance from "../api/axios";
import { getAllTherapist } from "../api/route";

export default function WixBridge() {
  const navigate = useNavigate();
  const { search } = useLocation();

  useEffect(() => {
    const q = new URLSearchParams(search);

    const userObj = {
      name: q.get("name") || "",
      phone: q.get("phone") || "",
      pinCode: q.get("pin") || "",
      address: q.get("city") || "",
      pain_condition: q.get("pain") || "",
      submissionType: "brand",
      source: q.get("source") || "brand_wix",
      utm_source_custom: q.get("utm_source"),
      utm_medium_custom: q.get("utm_medium"),
      utm_campaign_custom: q.get("utm_campaign"),
      utm_content_custom: q.get("utm_content"),
      utm_term_custom: q.get("utm_term"),
      utm_adgroup_custom: q.get("utm_adgroup"),
      gclid_custom: q.get("gclid"),
    };

    // Save in sessionStorage for SlotPage/BookingDetails
    sessionStorage.setItem("user", JSON.stringify(userObj));

    const go = async () => {
      try {
        // Check therapists for pincode
        const ther = await instance.get(`${getAllTherapist}?pinCode=${userObj.pinCode}`);
        if (Array.isArray(ther.data?.therapists) && ther.data.therapists.length > 0) {
          navigate("/booking-slot", { replace: true });
        } else {
          navigate("/empty-slot", { replace: true });
        }
      } catch (err) {
        console.error("WixBridge error", err);
        navigate("/booking-slot", { replace: true });
      }
    };

    go();
  }, [navigate, search]);

  return null;
}
